export default "/no2.6675764e-24e9bf.svg";